import { render, staticRenderFns } from "./ImagemModal.vue?vue&type=template&id=a4642a92&scoped=true"
import script from "./ImagemModal.vue?vue&type=script&lang=js"
export * from "./ImagemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4642a92",
  null
  
)

export default component.exports